import React from 'react';
import { CheckboxOption } from './checkbox_option';

class CheckboxGroup extends React.Component {
  buildCheckboxGroup() {
    const result = [];
    this.props.options.map((option, index) => {
      const display = this.props.strings ? this.props.strings[option.stringKey] : option.display;
      return result.push(
        <div className="form-group" key={index}>
          <CheckboxOption
            key={this.props.value}
            id={option.key}
            index={index}
            name={option.key}
            onClick={this.props.onClick}
            checked={option.enabled}
            value={option.value}
          />
          <label htmlFor={option.key}>{display}</label>
          {option.content ? option.content : ''}
        </div>
      );
    });
    return result;
  }

  render() {
    return <div>{this.buildCheckboxGroup()}</div>;
  }
}

export { CheckboxGroup };
